import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { NotificationService, Notification, NotificationType } from '../../services/notification.service';

@Component({
  selector: 'renci-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit, OnDestroy {

  notifications: Notification[] = [];
  private _subscription: Subscription;

  constructor(private _notificationSvc: NotificationService) { }

  ngOnInit() {
    this.notifications = this._notificationSvc.notifications;
    this._subscription = this._notificationSvc.notificationsChanged.subscribe(notifications => {
      this.notifications = notifications;
    });
  }

  ngOnDestroy() {
    if (this._subscription) {

      this._subscription.unsubscribe();
    }
  }

  close(notification: Notification) {
    this._notificationSvc.close(notification);
  }

  getType(notification: Notification): string {
    switch (notification.type) {
      case NotificationType.success:
        return 'success';
      case NotificationType.warning:
        return 'warning';
      case NotificationType.error:
        return 'danger';
      default:
        return 'info';
    }
  }


  className(notification: Notification): string {

    let style: string;

    switch (notification.type) {

      case NotificationType.success:
        style = 'success';
        break;

      case NotificationType.warning:
        style = 'warning';
        break;

      case NotificationType.error:
        style = 'error';
        break;

      default:
        style = 'info';
        break;
    }

    return style;
  }

}
